import { Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaHouseFormBuilder } from './ea-house-form.builder';

@Component({
    selector: 'ea-house-form',
    templateUrl: './ea-house-form.component.html',
    styleUrls: ['./ea-house-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaHouseFormComponent),
        },
    ],
    standalone: false
})
export class EaHouseFormComponent extends EaHouseFormBuilder implements OnInit {
  users: any[];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  maritalStatus: any[];
  marriageRegime: any[];
  countries = [];

  toValue: PlaceSearchResult = { address: '' };

  filteredMarriageRegime: any[];
  situations: any[] = ['OWNER', 'TENANT', 'HOSTED'];

  @ViewChild(PrModalConfirmComponent, { static: true })
  spousePurgeModal: PrModalConfirmComponent;

  hasSpouse: boolean = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.referenceDao.getMaritalStatus(),
      this.referenceDao.getMarriageRegime(),
      this.referenceDao.getCountries(),
    ]).subscribe(([maritalStatus, marriageRegime, countries]) => {
      this.maritalStatus = maritalStatus;
      this.marriageRegime = marriageRegime;
      this.filteredMarriageRegime = _.filter(
        this.marriageRegime,
        m => m.id == 'INDIVISION' || m.id == 'SEP_BIEN',
      );
      this.countries = countries;
    });

    this.userDao
      .getCouple()
      .subscribe((couple: any[]) => (this.hasSpouse = !!couple && !!couple[1]));
  }

  onSituationButtonClick() {
    const situationControl = this.form.get('situation.situation');
    this.mainAddress.situation = situationControl.value;
  }

  updateMaritalStatus() {
    let matrimonialRegime = this.form.controls
      .matrimonialRegime as UntypedFormGroup;
    if (
      matrimonialRegime.controls.maritalSituation.value != 'SINGLE' &&
      matrimonialRegime.controls.maritalSituation.value != 'WIDOWER' &&
      matrimonialRegime.controls.maritalSituation.value != 'DIVORCED'
    ) {
      matrimonialRegime.controls.regime.setValidators([Validators.required]);
      matrimonialRegime.controls.regime.setValue(this.marriageRegime[0].id);
    }
  }

  get selectedMarriageRegime(): any[] {
    const maritalSituation = this.form.get(
      'matrimonialRegime.maritalSituation',
    ).value;

    if (maritalSituation === 'MARRIED') {
      return this.marriageRegime;
    } else if (maritalSituation === 'CIVILPARTNER') {
      return this.filteredMarriageRegime;
    }

    return [];
  }

  onSubmit() {
    if (this.isSpousePatrimonyLost()) {
      this.spousePurgeModal.open();
      return;
    }

    this.save();
  }

  confirmSpousePurge() {
    this.save();
  }

  private isSpousePatrimonyLost(): boolean {
    const value = this.form.get('matrimonialRegime.maritalSituation').value;

    if (!value || !this.hasSpouse) {
      return false;
    }

    return (
      ['MARRIED', 'CIVILPARTNER', 'LIVETOGETHER', 'WIDOWER'].indexOf(value) ===
      -1
    );
  }

  private save() {
    //Fetch every form controls value
    let formDTOExtraction = _.merge(this.entity, this.extract());
    const address = formDTOExtraction.address;
    const adresses = formDTOExtraction.addresses;
    const isMainAdress = adresses?.find(address => address.isMain);

    if (isMainAdress) {
      isMainAdress.zipCode = address.zipCode || isMainAdress.zipCode;
      isMainAdress.city = address.city || isMainAdress.city;
      isMainAdress.country = address.country || isMainAdress.country;
      isMainAdress.street = address.street || isMainAdress.street;
      isMainAdress.situation = address.situation || isMainAdress.situation;
    }

    delete formDTOExtraction.address;
    if (adresses.length === 0) {
      formDTOExtraction.addresses = [];
      const newAddress = {
        isMain: true,
        userId: this.entity.userId,
        zipCode: address.zipCode,
        city: address.city,
        country: address.country,
        street: address.street,
        situation: address.situation,
      };

      formDTOExtraction.addresses.push(newAddress);
    }
    this.prFormService.loading();
    this.userDao.updateHouse(formDTOExtraction).subscribe(
      success => {
        this.prFormService.loaded();
        this.doneSubject.next();
        this.notificationService.success('La sauvegarde a réussi');
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
      },
    );
  }
}
